(() => {
  function setup() {
    const root = document.querySelector('[data-tm-led-widget]');
    if (!root || root.dataset.ledReady === 'yes') return;
    root.dataset.ledReady = 'yes';
    const button = root.querySelector('[data-led-toggle]');
    const panel = root.querySelector('[data-led-body]');
    const symbol = root.querySelector('[data-led-symbol]');
    const total = root.querySelector('[data-led-total]');
    const priceLine = root.querySelector('[data-led-price-line]');
    const install = root.querySelector('[data-led-install]');
    const error = root.querySelector('[data-led-error]');
    const numberSelector = '[data-product-handle="' + root.dataset.ledProductHandle + '"][data-tm-handcrafted-configurator] [data-tm-house-number-input], [data-product-handle="' + root.dataset.ledProductHandle + '"][data-tm-wall-configurator] [data-tm-house-number-input]';
    const getNumber = () => document.querySelector(numberSelector);
    const digits = () => ((getNumber()?.value || '').match(/[0-9]/g) || []).length;
    const power = () => root.querySelector('input[name="tm-led-power"]:checked')?.value || 'Hardwired';
    const placement = () => root.querySelector('input[name="tm-led-placement"]:checked')?.value || (['bradley-aluminum','incline','thumbs-up-aluminum'].includes(root.dataset.ledProductHandle) ? 'Front trim' : 'Single set');
    const multiplier = () => placement() === 'Both sides' ? 2 : 1;
    const billedDigits = () => digits() * multiplier();
    const form = document.getElementById(root.dataset.formId);
    const stateKey = 'tm-led-selection-v1-' + root.dataset.ledProductHandle;
    let saved;
    try { saved = JSON.parse(sessionStorage.getItem(stateKey) || 'null'); } catch (_) {}
    if (saved) {
      panel.hidden = !saved.enabled;
      button.setAttribute('aria-expanded', String(!panel.hidden));
      symbol.textContent = panel.hidden ? '+' : '−';
      root.querySelectorAll('input[name="tm-led-power"]').forEach(input => {
        if (input.value === saved.power) input.checked = true;
      });
      if (root.dataset.ledSingle !== 'true') {
        root.querySelectorAll('input[name="tm-led-placement"]').forEach(input => {
          if (input.value === saved.placement) input.checked = true;
        });
      }
    }
    const save = () => {
      try {
        sessionStorage.setItem(stateKey, JSON.stringify({
          enabled: !panel.hidden, power: power(), placement: placement()
        }));
      } catch (_) {}
    };
    const update = () => {
      if (!root.isConnected) return;
      save();
      const count = digits();
      const hardwired = power() === 'Hardwired';
      if (install) install.hidden = !hardwired;
      if (priceLine) priceLine.hidden = count === 0;
      if (total) total.textContent = count ? '$' + (count * multiplier() * 100 + (power() === 'Existing' ? 0 : power() === 'Solar' ? 200 : 60)).toLocaleString() : '';
    };
    button.addEventListener('click', () => {
      panel.hidden = !panel.hidden;
      button.setAttribute('aria-expanded', String(!panel.hidden));
      symbol.textContent = panel.hidden ? '+' : '−';
      update();
    });
    root.addEventListener('change', update);
    document.addEventListener('input', event => {
      if (event.target.matches(numberSelector)) update();
    });
    if (form) form.addEventListener('submit', async event => {
      if (!root.isConnected || panel.hidden) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      error.hidden = true;
      const count = digits();
      if (!count) {
        error.textContent = 'Please enter your house numbers above.';
        error.hidden = false;
        getNumber()?.focus();
        return;
      }
      const data = new FormData(form);
      const variant = Number(data.get('id'));
      if (!variant) {
        error.textContent = 'Please select your mailbox configuration.';
        error.hidden = false;
        return;
      }
      const properties = {};
      for (const [key, val] of data.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match) properties[match[1]] = val;
      }
      properties['LED House Numbers'] = billedDigits() + ' illuminated digits replacing standard numbers';
      properties['LED Placement'] = placement();
      properties['LED Power Source'] = power();
      properties['LED Temperature'] = '4000K';
      const address = getNumber()?.value || '';
      const quantity = Math.max(1, Number(data.get('quantity') || 1));
      const items = [
        { id: variant, quantity, properties },
        { id: Number(root.dataset.digitVariant), quantity: billedDigits() * quantity, properties: { Mailbox: root.dataset.ledProduct, Address: address, Placement: placement() } }
      ];
      if (power() !== 'Existing') items.push({ id: Number(power() === 'Solar' ? root.dataset.solarVariant : power() === 'Converter' ? root.dataset.converterVariant : root.dataset.transformerVariant), quantity, properties: { Mailbox: root.dataset.ledProduct, Address: address } });

      // Give each configured purchase its own group, including repeated mailbox models.
      const tmGroupId = crypto.randomUUID();
      items.forEach((item, index) => {
        item.properties = item.properties || {};
        item.properties._tm_group = tmGroupId;
        item.properties._tm_role = index === 0 ? 'mailbox' : 'upgrade';
        item.properties._tm_per_mailbox = String(item.quantity / items[0].quantity);
      });
      const submit = form.querySelector('[type="submit"]');
      if (submit) submit.disabled = true;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) {
          const result = await response.json();
          throw new Error(result.description || result.message || 'Could not add the upgrade.');
        }
        window.location.assign('/cart');
      } catch (failure) {
        error.textContent = failure.message || 'Please try again.';
        error.hidden = false;
        if (submit) submit.disabled = false;
      }
    }, true);
    update();
    root.dispatchEvent(new Event('change', { bubbles: true }));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();